<template>
	<div class="login-container">
		<h1>Velkommen til</h1>
		<h1 class="font-italic">I sandhedens Tjeneste</h1>

		<p class="font-italic mt-3">Tryk for at logge ind</p>

		<div class="mb-3" v-if="error">
			<div class="alert alert-danger"><strong>Fejl:</strong> {{ error }}</div>
		</div>

		<div class="mb-3">
			<input class="form-control" placeholder="Kode" v-model="code" type="password" @keyup.13="login" />
		</div>

		<div class="button-container">
			<button class="btn btn-dark btn-block" v-on:click="login" :disabled="!canLogin">Login{{ checkingCode ? '..' : '' }}</button>
		</div>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';

	export default {
		name: 'manager-login-view',
		components: {
		},
		data() {
			return {
				code: null,
				checkingCode: false,

				error: null,
			}
		},
		methods: {
			login() {
				this.checkingCode = true;
				this.error = null;

				this.$apiClient.getHttp().defaults.headers.common['X-Manager-Code'] = this.code;

				this.$apiClient.verifyManagerCode().then(() => {
					this.$router.push('/manager/section');
				}).catch((e) => {
					this.checkingCode = false;

					this.error = 'Kunne ikke logge ind. Prøv igen.';
				});
			}
		},
		computed: {
			canLogin() {
				if (this.checkingCode) {
					return false;
				}

				return !!this.code;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login-container {
		@include alignCenter();

		background: #f0f0f0;
		padding: 50px;
	}

	.logo-container {
		text-align: center;

		margin: 0 auto;

		img {
			max-width: 200px;
		}
	}

	h1 {
		text-align: center;
		line-height: 100%;

		margin-bottom: 0;
	}

	p {
		text-align: center;
		font-size: 10pt;
	}

	.button-container {
		text-align: center;
	}
</style>
